__webpack_require__.p = "/option-tech-charts/";